import { createApp } from 'vue'
import ConfirmPop from '../confirm_pop';
import MyI18n from '../plugins/my_i18n'
//import { createApp } from 'vue';
  /* eslint-disable no-new */
document.addEventListener('DOMContentLoaded', () => {
  const da = document.querySelector("#confirmpop");
  const cProps = {
    text: da.dataset.text
  };
  const app = createApp(ConfirmPop, cProps);
  app.use(MyI18n)

  app.mount("#confirmpop");
});

/*
const app = createApp(
  {
    props: ['signURL'],
  },
  { signURL: 'Evan' }
  )
createApp(Pop).mount("#pop");
*/
